// extracted by mini-css-extract-plugin
export default {"teamsBlock":"TeamsBlock_teamsBlock__ZLQBp","teamCardList":"TeamsBlock_teamCardList__xa9DX"};